import { Tooltip } from "@fluentui/react-components";
import { Info16Regular } from "@fluentui/react-icons";
import { ILabelWithInfoProps } from "./labelWithInfo.types";

export const LabelWithInfo = ({
  label,
  info,
  required = false,
}: ILabelWithInfoProps & { required?: boolean }): JSX.Element => (
  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
    <span>
      {label}
      {required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
    </span>
    <Tooltip content={info} relationship="description" withArrow>
      <Info16Regular
        aria-label={`${label} info`}
        style={{ cursor: "pointer" }}
      />
    </Tooltip>
  </div>
);
